/**
 * Generates an ICMJE Disclosure status label.
 * @param {Array} formList - List of ICMJE form objects.
 * @param {Array} form - The ICMJE form array (to check submission status).
 * @returns {string} A formatted label like "2/3 ICMJE Disclosure Submitted".
 */
import {
  IAuthorICMJEForm,
  IAuthorICMJEFormList
} from '@publishing-engine/domain/models';
import dateFormat from 'dateformat';

export function getIcmjeDisclosureLabel(
  formList: IAuthorICMJEFormList[],
  form: IAuthorICMJEForm[]
) {
  const uploadedCount = formList.filter(f => f?.isUploaded).length;
  const totalCount = formList.length;
  const status = form?.[0]?.file?.url ? 'Submitted' : 'Uploaded';
  return `${uploadedCount}/${totalCount} Forms and Disclosures ${status}`;
}

export function getICMJEContext(icmjeForm: IAuthorICMJEForm[]) {
  return icmjeForm?.[0]?.file.url
    ? icmjeForm?.[0]?.editorUpdated
      ? `The editorial office submitted the Forms and Disclosures form(s) on ${dateFormat(
          icmjeForm?.[0].date,
          'mmmm d, yyyy'
        )}.`
      : `A form was submitted to the Editors${
          icmjeForm?.[0]?.date
            ? ` on ${dateFormat(icmjeForm?.[0].date, 'mmmm d, yyyy')}`
            : ''
        }.`
    : `A form is required to support the Forms and Disclosures.`;
}
